import * as React from 'react';
import { useGetContractorQuery } from "../../../apis/Contractor.api";
import { PrimaryContractor, Contractor } from "../../../types/models/Contractor";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Contractor;
};

export const ContractorNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ContractorName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetContractorQuery(PrimaryContractor.fromId(id))
    return (<ContractorNameDisplay data={data}/>)
}

export default ContractorName;
